import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";



const EditProductFuelType = () => {
    const token = localStorage.getItem("authToken");
    const [formData, setFormData] = useState({});
    const location = useLocation();
    const [validationErrors, setValidationErrors] = useState({});
    const { data } = location.state || {};
    console.log(data, "fuelTypeData");
    const [loading, setLoading] = useState(false);
    const userType = localStorage.getItem("UserType")
    const businessPartnerId = localStorage.getItem("business_partner_id")
    const authToken = localStorage.getItem("authToken");
    const [ userTypedd, setUserTypedd ] = useState([])

    const [editFuelType, setEditFuelType] = useState([]);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    useEffect(() => {
        fetchFuelTypeEdit();
    }, []);

    // useEffect(() => {
    //     if (data) {
    //         console.log("fuelTypeData", data);
    //         const transformedData = {
    //             fuel_type_name: data.fuel_type_name,
    //             fuel_type_desc: data.fuel_type_desc,
    //             status: { label: data.status, value: data.status },
    //         };
    //         setFormData(transformedData);
    //         console.log(transformedData, "transformedData");
    //     }
    // }, [data]);

    useEffect(() => {
        userTypedropdown()
      },[])
      
      const userTypedropdown = async () => {
        try{
          const response = await axiosInstance.get("/bp-onboard/bplist",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          })
      
          const data = response.data.data.data
          const userTypeOptions = data.map(user => ({
            value: user.onboard_id,
            label:user.bp_name,
          }))
          setUserTypedd(userTypeOptions)
        }catch(error) {
          console.log(error)
        }
      }

    const navigate = useNavigate();

    const fetchFuelTypeEdit = async () => {
        try {
            const response = await axiosInstance.get(`/fueltype/edit/${data.fuel_type_id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const fetchedData = response.data.data;

            const transformedData = {
                business_partner_id:fetchedData.business_partner_id,
                fuel_type_name: fetchedData.fuel_type_name,
                fuel_type_desc: fetchedData.fuel_type_desc,
                status: fetchedData.status
            };
            setFormData(transformedData); // Assuming response.data is an object
            setEditFuelType(fetchedData);
            console.log("fetchedData", fetchedData);
        } catch (error) {
            console.log(error);
        }
    };
    const handleFormSubmit = async (formData) => {
      try {
          setIsFormSubmitted(true);
          console.log("fuelformdata", formData);
  
          // Show confirmation alert before proceeding
          showCustomAlert({
              title: "Confirm Update",
              text: "Are you sure you want to update the Fuel Type?",
              confirmButtonText: "Yes",
              cancelButtonText: "Cancel",
              icon: "warning",
              callback: async () => {
                  setLoading(true); // Start loading
  
                  const payload = {
                      fuel_type_name: formData.fuel_type_name,
                      fuel_type_desc: formData.fuel_type_desc,
                    status: formData.status,
                  };
  
                  if (userType === "superadmin") {
                      payload.business_partner_id = formData.business_partner_id;
                  } else {
                      payload.business_partner_id = businessPartnerId;
                  }
  
                  try {
                      // Send the update request
                      const response = await axiosInstance.patch(`/fueltype/update/${data.fuel_type_id}`, payload, {
                          headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${token}`,
                          },
                      });
  
                      console.log("Update successful!", response.data);
  
                      // Show success alert after successful update
                      showCustomAlert({
                          title: "Success",
                          text: "Fuel Type updated successfully.",
                          confirmButtonText: "OK",
                          icon: "success",
                          callback: () => {
                              navigate(ROUTES_NAVIGATION.PRODUCTFUELTYPELIST);  // Navigate after user clicks OK
                          },
                      });
                  } catch (error) {
                      console.error("Error updating product fuel type:", error);
                      
                      // Handle error and show error alert if needed
                      const errorMessage = error.response?.data?.message || "An error occurred while updating the fuel type.";
                      
                      showErrorAlert({
                          title: "Something went wrong",
                          text: errorMessage,
                          callback: () => {
                              console.log("Error alert confirmed");
                          },
                      });
                  } finally {
                      setLoading(false); // Stop loading regardless of success or failure
                  }
              },
          });
      } catch (error) {
          console.error("Unexpected error:", error);
          
          // Handle any unexpected errors (this should not trigger during the API call)
          showErrorAlert({
              title: "Unexpected Error",
              text: "An unexpected error occurred. Please try again.",
              callback: () => {
                  console.log("Unexpected error alert confirmed");
              },
          });
      }
  };
  
  
  

    const ProductFuelTypeInputs = [
        ...(userType === "superadmin"
            ? [
                {
                  name: "business_partner_id",
                  label: "Business Partner",
                  type: "dropdown",
                  required: true,
                  options: userTypedd,
                  gridClass: "col-lg-4",
                  validation: {
                    required: true,
                    pattern: /^[A-Za-z0-9 ]*$/,
                    message: "Only alphabets and digits are allowed",
                  },
                },
              ]
            : []),
        {
          name: "fuel_type_name",
          label: "Name",
          type: "text",
           validation: {
              required: true,
              pattern: /^[A-Za-z\s]*$/,
              message: "Only alphabets are allowed",
            },
          required: true,
          gridClass: "col-lg-4",
        },
        {
          name: "fuel_type_desc",
          label: "Description",
          type: "text",
          required: true,
          gridClass: "col-lg-4",
        },
        {
          name: "status",
          label: "Status",
          type: "dropdown",
          required: true,
          options: [
            { label: "Active", value: 1 },
            { label: "Inactive", value: 0 },
          ],
          gridClass: "col-lg-4",
        },
      ];

    return (
        <>
           <div>
    {loading ? (
      <Loader />
    ) : (
            <><div className="backbutton mt-2 mb-2">
                <img src={backicon} alt="back" onClick={() => navigate(ROUTES_NAVIGATION.PRODUCTFUELTYPELIST)} />
                <span className="backbtntitle">Edit Product Fuel Type</span>
              </div><div className="form-container">
                  <span className="cust-det-title mt-2 mb-2">
                    Please Edit Product Fuel Type Details
                  </span>
                  <DynamicForm
                    formConfig={ProductFuelTypeInputs}
                    formData={formData}
                    setFormData={setFormData}
                    onSubmit={handleFormSubmit}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors} />
                </div><div className="btncontainer mt-3">
                  <button
                    onClick={() => handleFormSubmit(formData)}
                    className="submit-btn"
                  >
                    Submit
                  </button>
                </div></>
             )}
    </div>
        </>
    );
};

export default EditProductFuelType;
